/* eslint-disable */
import React, { Component } from 'react';
import _ from 'lodash';
import Slider from 'react-slick';
import Loader from 'react-loader';
import { connect } from 'react-redux';
import { formValueSelector, reduxForm } from 'redux-form';
import SelectField from '../shared/SelectField';

const selector = formValueSelector('management');

class Management extends Component {
  constructor(props) {
    super(props);
    this.reInitialize = this.reInitialize.bind(this);
    this.loadDocs = this.loadDocs.bind(this);
  }

  componentWillMount() {
    this.props.didMount();
    window.scrollTo(0, 0);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.myValues.faculty
        && nextProps.myValues.cathedra
        && nextProps.myValues.academicYear
        && !_.isEqual(nextProps.myValues, this.props.myValues)) {
      this.props.getGroup(nextProps.myValues);
    }
    if (nextProps.myValues.academicPeriod
      && nextProps.myValues.group
      && !_.isEqual(nextProps.myValues, this.props.myValues)) {
      this.props.getDiscipline(nextProps.myValues);
    }
    if (nextProps.cathedra && !_.isEqual(this.props.cathedra, nextProps.cathedra)) {
      this.reInitialize('cathedra', 'idcathedra', nextProps.management);
    }
    if (nextProps.discipline && !_.isEqual(this.props.discipline, nextProps.discipline)) {
      this.reInitialize('discipline', 'cid', nextProps.management);
    }
    if (nextProps.academicPeriod && !_.isEqual(this.props.academicPeriod, nextProps.academicPeriod)) {
      this.reInitialize('academicPeriod', 'trmid', nextProps.management);
    }
  }

  loadDocs() {
    if (this.props.myValues.academicPeriod
      ) {
      this.props.getTestResult(this.props.myValues);
    }
  }

  reInitialize(fieldName, fieldId, managementLocal) {
    const { change, management } = this.props;
    this.props.dispatch(change(fieldName, managementLocal
      ? managementLocal[fieldName][0] && managementLocal[fieldName][0][fieldId]
      : management[fieldName][0] && management[fieldName][0][fieldId]));
  }

  render() {
    const {
      getAcademicPeriod, getCathedra, academicYear, faculty, academicPeriod, handleSubmit,
      testResult, testResultPhotos, cathedra, group, discipline, control, academicPeriodLoading,
    } = this.props;
    return (
      <div>
        <div className="16jpg">
          <div className="captions">Проведение зачетных и экзаменационных сессий</div>
          <div className="session justify-content">
            <div className="session-left">
              {<div className="session-lebel">
                <p>Факультет</p>
                <p className="Mg-sessionLebel__cafedraText">Кафедра</p>
                <p>Дисциплина</p>
              </div>}
              <div className="inputs__input Mg-select">
                <SelectField
                  className="input__caption"
                  nameObj="faculty"
                  valueObj="idfaculty"
                  name="faculty"
                  options={faculty && faculty}
                  onChange={(val) => {getCathedra(val.target.value)}}
                />
              </div>
              <div className="inputs__input Mg-select Mg-selectCafedra">
                <SelectField
                  className="inputs__own-ses"
                  nameObj="cathedra"
                  valueObj="idcathedra"
                  name="cathedra"
                  options={cathedra && cathedra}
                />
              </div>
              <div className="inputs__input Mg-select Mg-selectDiscipline">
                <SelectField
                  className="inputs__own-ses"
                  nameObj="course"
                  valueObj="cid"
                  name="discipline"
                  options={discipline && discipline}
                />
              </div>
              <a
                className="Ms-writeMessage Mg-refresh"
                onClick={() => this.loadDocs()}
              >Обновить</a>
              <table>
                <tbody>
                  <tr>
                    <th className="table-title">№</th>
                    <th className="table-title">Фамилия имя отчество</th>
                    <th className="table-title">15.01 (Э)</th>
                    <th className="table-title">Ср. балл</th>
                  </tr>
                  {testResult && testResult.participants.map((result, index) =>
                    (<tr key={index}>
                      <td className="col">{index + 1}</td>
                      <td className="col2">{result.student}</td>
                      <td>{result.grade}</td>
                      <td>{testResult.participants.length >= index + 6 ? `${result.grade}.00` : result.grade}</td>
                    </tr>),
                  )}
                </tbody>
              </table>
              <div className="contr-button session-button">
                <button onClick={handleSubmit(val => console.log(val))}>Добавить</button>
                <button onClick={() => this.loadDocs()}>Экз. комиссия</button>
                <button>Закрыть ведомость</button>
              </div>
            </div>
            <div className="session-right Mg-sessionRight">
              <div className="right-lebel">
                <p>Учебный год</p>
                <p>Учебный период</p>
                <p>Группа</p>
                <p>Форма контроля</p>
              </div>
              <div className="session-input-right">
                <div className="usp__inputs-ses Mg-sessionRight__select">
                  <SelectField
                    className="inputs__own-ses"
                    nameObj="name"
                    valueObj="xp_key"
                    name="academicYear"
                    options={academicYear && academicYear}
                    onChange={(val) => {
                      getAcademicPeriod(val.target.value);
                      this.reInitialize('group', 'gid');
                    }}
                  />
                </div>
                <div className="usp__inputs-ses Mg-sessionRight__select">
                  <Loader
                    color="#7b2b2a"
                    loaded={!academicPeriodLoading}
                  >
                    <SelectField
                      className="inputs__own-ses"
                      nameObj="title"
                      valueObj="trmid"
                      name="academicPeriod"
                      options={academicPeriod && academicPeriod}
                      onChange={(val) => {
                        this.reInitialize('group', 'gid');
                      }}
                    />
                  </Loader>
                </div>
                <div className="usp__inputs-ses Mg-sessionRight__select">
                  <SelectField
                    className="inputs__own-ses"
                    nameObj="name"
                    valueObj="gid"
                    name="group"
                    options={group && group}
                  />
                </div>
                <div className="usp__inputs-ses">
                  <SelectField
                    className="inputs__own-ses"
                    nameObj="testtype"
                    valueObj="typeid"
                    name="control"
                    options={control && control}
                  />
                </div>
              </div>
              <p className="Mg-slider__title">Сканы ведомостей</p>
              <div className="Mg-sliderWrapper">
                <Slider
                  className="Mg-slider"
                  arrows
                  swipe={false}
                >
                  {testResultPhotos && testResultPhotos.map((document,index) =>
                    (<div key={index}>
                      <img alt="" className="session-document" src={document && document.photo} />
                    </div>),
                  )}
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const managementForm = reduxForm({
  form: 'management',
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
})(Management);

export default connect(
  state => ({
    myValues: selector(state, 'academicYear', 'faculty', 'academicPeriod', 'cathedra', 'group', 'discipline', 'control'),
  }),
)(managementForm);
